import Vue from 'vue'
import Router from 'vue-router'

// import app pages
import Home from '../components/Home'
import Admin from '../components/Admin'
import Login from '../components/Admin/Login'

// import admin page components
import Posts from '../components/Admin/content/Posts'
import PostNew from '../components/Admin/content/PostNew'
import PostEdit from '../components/Admin/content/PostEdit'
import Settings from '../components/Admin/content/Settings'
import Pages from '../components/Admin/content/Pages'
import Media from '../components/Admin/content/Media'
import Users from '../components/Admin/content/Users'
import UserNew from '../components/Admin/content/UserNew'
import Database from '../components/Admin/content/Database'
import Galleries from '../components/Admin/content/Galleries'
import GalleriesNew from '../components/Admin/content/GalleriesNew'
import GalleriesEdit from '../components/Admin/content/GalleriesEdit'
import Testimonials from '../components/Admin/content/Testimonials'
import TestimonialsNew from '../components/Admin/content/TestimonialsNew'
import TestimonialsEdit from '../components/Admin/content/TestimonialsEdit'
import Properties from '../components/Admin/content/Properties'
import PropertiesEdit from '../components/Admin/content/PropertiesEdit'
import Locations from '../components/Admin/content/Locations'
import LocationsEdit from '../components/Admin/content/LocationsEdit'
import Accommodations from '../components/Admin/content/Accommodations'
import AccommodationsNew from '../components/Admin/content/AccommodationsNew'
import AccommodationsEdit from '../components/Admin/content/AccommodationsEdit'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/frontpage',
      name: 'Home',
      component: Home
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      children: [
        {
          path: 'posts',
          component: Posts,
          children: [
            {
              path: 'new',
              component: PostNew
            },
            {
              path: 'edit/:key',
              component: PostEdit
            }
          ]
        },
        {
          path: 'settings',
          component: Settings
        },
        {
          path: 'pages',
          component: Pages
        },
        {
          path: 'media',
          component: Media
        },
        {
          path: 'database',
          component: Database
        },
        {
          path: 'users',
          component: Users
        },
        {
          path: 'users/new',
          component: UserNew
        },
        {
          path: 'galleries',
          component: Galleries,
          children: [
            {
              path: 'new',
              component: GalleriesNew
            },
            {
              path: 'edit/:key',
              component: GalleriesEdit
            }
          ]
        },
        {
          path: 'testimonials',
          component: Testimonials,
          children: [
            {
              path: 'new',
              component: TestimonialsNew
            },
            {
              path: 'edit/:key',
              component: TestimonialsEdit
            }
          ]
        },
        {
          path: 'properties',
          component: Properties,
          children: [
            // {
            //   path: 'new',
            //   component: PropertiesNew
            // },
            {
              path: 'edit/:key',
              component: PropertiesEdit
            }
          ]
        },
        {
          path: 'locations',
          component: Locations,
          children: [
            // {
            //   path: 'new',
            //   component: LocationsNew
            // },
            {
              path: 'edit/:key',
              component: LocationsEdit
            }
          ]
        },
        {
          path: 'accommodations',
          component: Accommodations,
          children: [
            {
              path: 'new',
              component: AccommodationsNew
            },
            {
              path: 'edit/:key',
              component: AccommodationsEdit
            }
          ]
        }
      ]
    },
    {
      path: '*',
      name: 'default',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js